module.exports = __webpack_public_path__ + "img/JAOC_POP_PestoSauce_oval.9225e5cb.png";